import { GridRenderCellParams } from "@mui/x-data-grid";

export class ComunidadAutonoma {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public name: string | undefined;
}